import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { HttpRequestService } from 'src/app/common/services/http-request.service';
import { Utils } from 'src/app/common/services/utils.service';
import { ReworkConfigService } from '../rework-config.service';

@Component({
  selector: 'app-split-modal',
  templateUrl: './split-modal.component.html',
  styleUrls: ['./split-modal.component.css']
})
export class SplitModalComponent implements OnInit {

  splitTableDatasource: any[];
  splitTableConfigs: object;
  splitTableColumnConfigs: object;
  splitTableCallbacks: object = {};
  selectedItem: object;
  isCompute = false;
  canRestrictSplitOrCompute = true;
  isConfirmed = false;
  successResponse: any;

  constructor(public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private reworkService: ReworkConfigService,
    private httpService: HttpRequestService,
    private utils: Utils) { }

  fetchSplittableItems() {
    const reqData = {
      'strPlanNo': this.reworkService.selectedReworkItems['PLAN_NO'],
      'strRequestType': this.reworkService.selectedItemToSplit['REQ_TYPE'],
      'iPlanLine': this.selectedItem['PLAN_LINE']
    };
    const requestData = this.utils.constructRequestData(reqData, 'CorePlanningService', 'initSplitLine');
    this.httpService.configRequestDataWithHeaders(requestData, 'post', '')
      .subscribe((response: object) => {
        const tableSource = this.utils.findAndSetGridSource(response['grid_array'], 'plandetailsid');
        this.splitTableDatasource = tableSource.length ? tableSource : [];
      });
  }

  onCloseModal() {
    this.ref.close(this.isConfirmed ? this.successResponse : undefined);
  }

  refreshGrid(response) {
    const gridResponse = response['grid_array'];
    const splitGridArray = this.utils.findAndSetGridSource(gridResponse, 'plandetailsid');
    const planDetailGridArray = this.utils.findAndSetGridSource(gridResponse, 'plandetailsid');
    // const splittedGridArray = isValidGridList ? gridResponse[0].plandetailsid : [];
    this.utils.insertIdFieldInDataSource(splitGridArray);
    this.utils.insertIdFieldInDataSource(planDetailGridArray);

    this.splitTableCallbacks['scope'].dataset = splitGridArray;
    this.splitTableCallbacks['scope'].dataViewObj.refresh();
  }

  onConfirmSplit(methodName?: string) {
    const gridArray = this.splitTableCallbacks['scope'].dataset;
    const selectedRow = this.splitTableCallbacks['getSelectedRows'](this.splitTableCallbacks['scope'])[0];
    gridArray.forEach(element => {
      element.select = element.PLAN_LINE === selectedRow.PLAN_LINE;
    });
    const reqData = {
      'strPlanNo': this.reworkService.selectedReworkItems['PLAN_NO'],
      'plandetailsid_array': gridArray,
      'iPlanLine': this.selectedItem['PLAN_LINE'],
      'chkContSch': this.config.data.fixedVehAllocation,
      'strRequestType': this.reworkService.selectedItemToSplit['REQ_TYPE'],
      'strAction': !methodName ? this.isCompute : undefined
    };
    const requestData = this.utils.constructRequestData(reqData, 'CorePlanningService', methodName ? methodName : 'splitPlanLines');
    this.httpService.configRequestDataWithHeaders(requestData, 'post', '')
      .subscribe((response: any) => {
        if (response.strFailureMsg) {
          this.utils.showNotification(response.strFailureMsg, 'error', 'Error proccessing your request');
          return;
        }
        this.isConfirmed = true;
        this.successResponse = response;
        this.refreshGrid(response);
      });
  }

  onCompute() {
    this.isCompute = true;
    this.onConfirmSplit('splitPlanLinesCal');
  }

  onGridSelectionChanges(event) {
    this.canRestrictSplitOrCompute = (event.rows.length === 0);
  }

  ngOnInit() {
    this.selectedItem = this.reworkService.selectedItemToSplit;
    this.fetchSplittableItems();
    this.splitTableColumnConfigs = this.reworkService.getSplitConfigTableColumnConfigs(this);
    this.splitTableConfigs = this.reworkService.getSplitTableConfigs();
  }
}
